<template>
  <span>
    <span v-if="!!job?.documents_signed_manually">
      <span class="badge badge-success">Documents Signed In Person</span>
    </span>
    <span :class="statusClass" v-else>
      {{ statusText }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
      required: false
    },
    status: {
      type: String,
      required: false
    }
  },
  computed: {
    statusClass() {
      switch (this.status) {
        case 'sent':
        case 'delivered':
          return 'badge badge-warning';
        case 'completed':
          return 'badge badge-success';
        case 'declined':
          return 'badge badge-danger';
        default:
          return 'badge badge-danger';
      }
    },
    statusText() {
      switch (this.status) {
        case 'sent':
          return 'Sent';
        case 'delivered':
          return 'Delivered';
        case 'completed':
          return 'Yes';
        case 'declined':
          return 'No';
        default:
          return 'Not Sent';
      }
    }
  }
};
</script>
